export const ADMIN_SCREEN_DASHBOARD = 1;
export const ADMIN_SCREEN_TERMINAL_BALANCE = 2;
export const ADMIN_SCREEN_BILL_FLOW = 3;
export const ADMIN_SCREEN_TRANSACTIONS = 4;
export const ADMIN_SCREEN_TICKET_OVERVIEW = 5;
export const ADMIN_SCREEN_FIND_TICKET = 6;
export const ADMIN_SCREEN_PARTIAL_PAYOUT_RECEIPTS = 7;
export const ADMIN_SCREEN_EVENT_LOG = 8;
export const ADMIN_SCREEN_QR_CODES = 9;
export const ADMIN_SCREEN_SETTINGS = 10;



// WEBPACK FOOTER //
// ./src/HOCs/Constants/AdminScreenIDs.js